import React from "react";
import { Icon } from "elements";

export default function Download({ size, className }) {
  return (
    <Icon size={size} className={className}>
      <path
        d="M11.25 4.5L11.25 13.6275L7.0575 9.435L6 10.5L12 16.5L18 10.5L16.9425 9.4425L12.75 13.6275L12.75 4.5L11.25 4.5Z"
        fill="currentColor"
      />
      <rect x="6.75" y="18" width="10.5" height="1.5" fill="currentColor" />
    </Icon>
  );
}



// WEBPACK FOOTER //
// ./src/core/icons/components/Download.jsx